import React, { useState } from 'react';

import {
  List,
  Datagrid,
  TextField,
  usePermissions,
} from 'react-admin';

import { Card, Divider } from '@mui/material';

import hasAccess from '../../utilities/hasAccess';

import { SubListNavigation } from '../layout/SubNavigation';
import { StyledTab, StyledTabs } from '../layout/Tab';
import Pagination from '../layout/Pagination';
import NoResults from '../layout/NoResults';

import TransactionTypeCreate from './TransactionTypeCreate';
import TransactionTypeEdit from './TransactionTypeEdit';

import actions, { Actions } from '../../constants/actions';
import { boldDataGridStyle } from '../../constants/style/datagridStyles';

const TransactionTypeActions = () => {
  const { permissions } = usePermissions<Actions[]>();

  if (!hasAccess(permissions, actions.TRANSACTION_TYPE_CREATE)) return null;
  return (
    <TransactionTypeCreate />
  );
};

const TransactionTypeList = () => {
  const [activationTab, setActivationTab] = useState(0);
  const [active, setActive] = useState(true);
  const { permissions } = usePermissions<Actions[]>();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActivationTab(() => newValue);
    setActive(() => newValue === 0);
  };
  return (
    <List
      empty={false}
      filter={{ active }}
      actions={<TransactionTypeActions />}
      pagination={<Pagination disableEmptyText />}
      exporter={false}
      perPage={50}
    >
      <Card sx={{ margin: 0 }} variant="outlined">
        <Card sx={{ margin: 0 }}>
          <SubListNavigation>
            <StyledTabs value={activationTab} onChange={handleChange}>
              <StyledTab label="Active " />
              <StyledTab label="Inactive" />
            </StyledTabs>
          </SubListNavigation>
          <Divider />
        </Card>
        <Datagrid sx={boldDataGridStyle} bulkActionButtons={false} empty={<NoResults variant="h6" />}>
          {hasAccess(permissions, actions.TRANSACTION_TYPE_GET) && <TransactionTypeEdit />}
          <TextField sortable={false} source="name" />
        </Datagrid>
      </Card>
    </List>
  );
};

export default TransactionTypeList;
